/* eslint-disable react/react-in-jsx-scope */
import Button from '@mui/material/Button'
import './../custombutton/custombutton.css'
import { CircularProgress } from '@mui/material'

const CustomButton = ({
  onClick,
  variant = 'contained',
  disabled = false,
  title = '',
  className = 'btn1',
  type = 'button',
  endIcon,
  startIcon,
  loading
}) => {
  const btnProps = {
    onClick,
    variant,
    disabled,
    className,
    type,
    ...(endIcon && { endIcon }),
    ...(startIcon && { startIcon })
  }
  return (
    <Button
      {...btnProps}
      variant={variant}
      disabled={loading || disabled}
      className={className}
      type={type}
      endIcon={endIcon}
      startIcon={startIcon}
      sx={{
        fontSize: '14px',
        fontWeight: '600',
        textTransform: 'capitalize',
        position: 'relative'
      }}
      onClick={onClick}
    >
      {loading
        ? (
        <CircularProgress size={20} color="inherit" />
          )
        : title}
    </Button>
  )
}

export default CustomButton
